import { c as _c } from "react/compiler-runtime";
import { CircularProgress, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { snapshotsBeingCreatedCountSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";
/**
 * Renders a line of primary-coloured text with a small spinner indicating how many snapshots
 * are currently being created. Renders `null` when no snapshots are being created.
 */
export function SnapshotsBeingCreatedIndicator(t0) {
  const $ = _c(14);
  const {
    sx
  } = t0;
  const snapshotsBeingCreatedCount = useAppSelector(snapshotsBeingCreatedCountSelector);
  if (snapshotsBeingCreatedCount === 0) {
    return null;
  }
  let t1;
  if ($[0] !== snapshotsBeingCreatedCount) {
    t1 = nounPluralize({
      counter: snapshotsBeingCreatedCount,
      word: "snapshot",
      shouldShowCounter: false
    });
    $[0] = snapshotsBeingCreatedCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const snapshotLabel = t1;
  let t2;
  if ($[2] !== sx) {
    t2 = {
      alignItems: "center",
      gap: 1,
      ...sx
    };
    $[2] = sx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CircularProgress size="1rem" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "primary.main"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== snapshotsBeingCreatedCount) {
    t5 = <var>{snapshotsBeingCreatedCount}</var>;
    $[6] = snapshotsBeingCreatedCount;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== snapshotLabel || $[9] !== t5) {
    t6 = <Text variant="bodyM" sx={t4}>{t5} {snapshotLabel} being created</Text>;
    $[8] = snapshotLabel;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <Stack direction="row" sx={t2}>{t3}{t6}</Stack>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}